import { useState } from "react";
import { FinanceSettingsLayout } from "./Components/FinanceSettingsLayout";
import { useMediaQuery } from "usehooks-ts";
import { SellarCreditTable } from "./Components/SellarCreditTable";
import type {
  PayoutListResponseType,
  NextPayoutResponseType,
} from "@sellar-io/api-v2/types";
import { SellarCreditsCardList } from "./Components/SellarCreditCardList";
import PayoutTable from "./Components/PayoutTable";
import { PayoutCardList } from "./Components/PayoutCardList";

export const FinanceSettingsSellarCredit = () => {
  const [active, setActive] = useState(false);
  const [selectedPayout, setSelectedPayout] = useState<
    PayoutListResponseType[number] | NextPayoutResponseType
  >();

  const isDesktop = useMediaQuery("(min-width: 1200px)");

  return (
    <FinanceSettingsLayout>
      {!active && isDesktop && (
        <SellarCreditTable
          setSelectedPayout={setSelectedPayout}
          setActive={setActive}
        />
      )}
      {!active && !isDesktop && (
        <SellarCreditsCardList
          setSelectedPayout={setSelectedPayout}
          setActive={setActive}
        />
      )}
      {selectedPayout && active && isDesktop && (
        <PayoutTable payout={selectedPayout} setActive={setActive} />
      )}
      {selectedPayout && active && !isDesktop && (
        <PayoutCardList payout={selectedPayout} setActive={setActive} />
      )}
    </FinanceSettingsLayout>
  );
};
